export default __webpack_public_path__ + "static/media/buttons-card-5.fc9a514d.svg";